var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{attrs:{"variant":"light"},on:{"click":function($event){return _vm.signIn()}}},[_c('img',{attrs:{"src":"/icons8_google_1.ico","alt":"icons8_google_1 icon"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }